/** @jsxImportSource @emotion/react */
import React from 'react'

import { LOGO_BTIME } from '../Constants'
import { getFieldInPx } from '../../_helpers/fieldInPixels'
import { useColor } from '../../../../../packages/kiti/components/theme/_hooks/colors'
import { usePdfOptionsForm } from '../../../../../components/pdf/options/_form/PdfOptionsFormHandler'
import Qrcode from '../../../../../containers/qrcodes/Qrcode'

const MinimalTemplate = ({ qrcode }) => {
  const form = usePdfOptionsForm()
  const bgColor = useColor(form.bgColor)
  const logoSize = getFieldInPx(form, 'logoSize')

  const defaultCSS = {
    fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "SF Pro Display", "Nunito", "Montserrat", sans-serif',
    lineHeight: '110%',
    textAlign: 'center',
    fontSize: '5px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical'
  }

  return (
    <svg
      width={form.templateWidth + 'cm'}
      height={form.templateWidth * (4 / 3) + 'cm'}
      version="1.1"
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 170.1 226.8"
    >
      <path
        style={{ fill: bgColor }}
        d="M153.1,226.8H17c-9.4,0-17-7.6-17-17V17C0,7.6,7.6,0,17,0h136.1c9.4,0,17,7.6,17,17v192.8
	C170.1,219.2,162.5,226.8,153.1,226.8z"
      />
      <path
        style={{ fill: '#ffffff' }}
        d="M132.3,184.3h-94c-7.8,0-14.2-6.3-14.2-14.2v-94c0-7.8,6.3-14.2,14.2-14.2h94c7.8,0,14.2,6.3,14.2,14.2v94
	C146.5,178,140.2,184.3,132.3,184.3z"
      />
      <g>
        <g>
          <path
            style={{ fill: '#ffffff' }}
            d="M75.1,193.8h0.6v2.8h-0.6V193.8z M75.4,195.3h0.7c0.2,0,0.3,0,0.4-0.1c0.1-0.1,0.1-0.2,0.1-0.4v0
			c0-0.2,0-0.3-0.1-0.4c-0.1-0.1-0.2-0.1-0.4-0.1h-0.7v-0.5h0.8c0.2,0,0.4,0,0.5,0.1s0.3,0.2,0.3,0.3s0.1,0.3,0.1,0.5v0
			c0,0.2,0,0.4-0.1,0.5s-0.2,0.3-0.3,0.3s-0.3,0.1-0.5,0.1h-0.8V195.3z"
          />
          <path
            style={{ fill: '#ffffff' }}
            d="M78,196.5c-0.2-0.1-0.3-0.2-0.4-0.4c-0.1-0.2-0.1-0.4-0.1-0.6v0c0-0.2,0-0.4,0.1-0.6s0.2-0.3,0.4-0.4
			c0.2-0.1,0.3-0.1,0.5-0.1c0.2,0,0.4,0,0.5,0.1c0.2,0.1,0.3,0.2,0.4,0.4s0.1,0.4,0.1,0.6v0c0,0.2,0,0.4-0.1,0.6
			c-0.1,0.2-0.2,0.3-0.4,0.4c-0.2,0.1-0.3,0.1-0.5,0.1C78.3,196.7,78.1,196.6,78,196.5z M78.8,196.2c0.1,0,0.1-0.1,0.2-0.2
			s0.1-0.2,0.1-0.3v0c0-0.1,0-0.2-0.1-0.3s-0.1-0.2-0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0.1s-0.1,0.1-0.2,0.2
			c0,0.1-0.1,0.2-0.1,0.3v0c0,0.1,0,0.3,0.1,0.3s0.1,0.2,0.2,0.2c0.1,0.1,0.2,0.1,0.2,0.1C78.6,196.2,78.7,196.2,78.8,196.2z"
          />
          <path
            style={{ fill: '#ffffff' }}
            d="M79.7,194.5h0.6l0.3,1.6h0l0.4-1.6h0.5l0.4,1.6h0l0.3-1.6h0.6l-0.6,2.1h-0.6l-0.4-1.5h0l-0.4,1.5h-0.6
			L79.7,194.5z"
          />
          <path
            style={{ fill: '#ffffff' }}
            d="M83.4,196.5c-0.2-0.1-0.3-0.2-0.4-0.4c-0.1-0.2-0.1-0.4-0.1-0.6v0c0-0.2,0-0.4,0.1-0.6
			c0.1-0.2,0.2-0.3,0.4-0.4c0.2-0.1,0.3-0.1,0.5-0.1s0.4,0,0.5,0.1c0.1,0.1,0.3,0.2,0.3,0.4c0.1,0.2,0.1,0.3,0.1,0.6v0.2h-1.7v-0.4
			h1.5l-0.3,0.3v-0.2c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1s-0.2,0-0.2,0.1s-0.1,0.1-0.2,0.2
			c0,0.1-0.1,0.2-0.1,0.3v0.2c0,0.1,0,0.2,0.1,0.3s0.1,0.1,0.2,0.2c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.1-0.1
			c0,0,0.1-0.1,0.1-0.1l0,0h0.5l0,0c0,0.1,0,0.2-0.1,0.2s-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.2s-0.2,0.1-0.4,0.1
			C83.7,196.7,83.6,196.6,83.4,196.5z"
          />
          <path
            style={{ fill: '#ffffff' }}
            d="M85.2,194.5h0.6v0.4h0c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.1,0.3-0.1c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0v0.5
			c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.2s-0.1,0.2-0.1,0.3v1.2h-0.6V194.5z"
          />
          <path
            style={{ fill: '#ffffff' }}
            d="M87.1,196.5c-0.2-0.1-0.3-0.2-0.4-0.4c-0.1-0.2-0.1-0.4-0.1-0.6v0c0-0.2,0-0.4,0.1-0.6
			c0.1-0.2,0.2-0.3,0.4-0.4c0.2-0.1,0.3-0.1,0.5-0.1c0.2,0,0.4,0,0.5,0.1c0.1,0.1,0.3,0.2,0.3,0.4c0.1,0.2,0.1,0.3,0.1,0.6v0.2h-1.7
			v-0.4h1.5l-0.3,0.3v-0.2c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0.1
			s-0.1,0.1-0.2,0.2c0,0.1-0.1,0.2-0.1,0.3v0.2c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.1,0.2,0.2c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.2,0
			c0.1,0,0.1-0.1,0.1-0.1c0,0,0.1-0.1,0.1-0.1l0,0h0.5l0,0c0,0.1,0,0.2-0.1,0.2c0,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.2
			s-0.2,0.1-0.4,0.1C87.4,196.7,87.2,196.6,87.1,196.5z"
          />
          <path
            style={{ fill: '#ffffff' }}
            d="M89.2,196.5c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1-0.2-0.1-0.4-0.1-0.6v0c0-0.2,0-0.4,0.1-0.6
			c0.1-0.2,0.2-0.3,0.3-0.4c0.1-0.1,0.3-0.1,0.5-0.1c0.2,0,0.3,0,0.4,0.1c0.1,0.1,0.2,0.2,0.3,0.3h0v-1.1h0.6v2.8h-0.6v-0.4h0
			c-0.1,0.1-0.1,0.2-0.3,0.3c-0.1,0.1-0.2,0.1-0.4,0.1C89.5,196.7,89.3,196.6,89.2,196.5z M90.1,196.1c0.1,0,0.1-0.1,0.2-0.2
			c0-0.1,0.1-0.2,0.1-0.3v0c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0.1
			c-0.1,0-0.1,0.1-0.2,0.2c0,0.1-0.1,0.2-0.1,0.3v0c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.2,0.2,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			C90,196.2,90,196.2,90.1,196.1z"
          />
          <path
            style={{ fill: '#ffffff' }}
            d="M92.9,196.6c-0.1-0.1-0.2-0.2-0.3-0.3h0v0.4h-0.6v-2.8h0.6v1.1h0c0.1-0.1,0.1-0.2,0.3-0.3
			c0.1-0.1,0.2-0.1,0.4-0.1c0.2,0,0.3,0,0.5,0.1c0.1,0.1,0.2,0.2,0.3,0.4c0.1,0.2,0.1,0.4,0.1,0.6v0c0,0.2,0,0.4-0.1,0.6
			c-0.1,0.2-0.2,0.3-0.3,0.4c-0.1,0.1-0.3,0.1-0.5,0.1C93.2,196.7,93,196.6,92.9,196.6z M93.4,196.1c0.1,0,0.1-0.1,0.2-0.2
			c0-0.1,0.1-0.2,0.1-0.3v0c0-0.1,0-0.2-0.1-0.3c0-0.1-0.1-0.2-0.2-0.2c-0.1-0.1-0.2-0.1-0.2-0.1c-0.1,0-0.2,0-0.2,0.1
			c-0.1,0.1-0.1,0.1-0.2,0.2c0,0.1-0.1,0.2-0.1,0.3v0c0,0.1,0,0.2,0.1,0.3c0,0.1,0.1,0.2,0.2,0.2c0.1,0.1,0.2,0.1,0.2,0.1
			C93.2,196.2,93.3,196.2,93.4,196.1z"
          />
          <path
            style={{ fill: '#ffffff' }}
            d="M94.6,197.3c-0.1,0-0.1,0-0.1,0v-0.4c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.2,0c0,0,0.1-0.1,0.1-0.1
			l0-0.1l-0.7-2.1h0.6l0.5,1.8l-0.1-0.1h0.1l-0.1,0.1l0.5-1.8h0.6l-0.7,2.1c-0.1,0.2-0.1,0.3-0.2,0.4c-0.1,0.1-0.2,0.2-0.3,0.2
			c-0.1,0-0.3,0.1-0.4,0.1C94.7,197.3,94.7,197.3,94.6,197.3z"
          />
        </g>
      </g>
      <image
        width="3236"
        height="1117"
        href={LOGO_BTIME}
        transform="matrix(1.409372e-02 0 0 1.409372e-02 62.5468 201.3685)"
      />
      <foreignObject x={24} y={0} width={123} height={62}>
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{ paddingTop: `${form.logoSpacing}cm`, display: 'flex', justifyContent: 'center' }}
        >
          <img src={form.customLogo?.preview} width={logoSize} />
        </div>
      </foreignObject>
      {form.activationDetails && qrcode?.data?.name && (
        <foreignObject width={100} height={12} x={35} y={170}>
          <div style={defaultCSS}>{qrcode?.data?.name?.toUpperCase()}</div>
        </foreignObject>
      )}
      <Qrcode x="41.5" y="78.5" qrcode={qrcode} size={88} />
    </svg>
  )
}

export default MinimalTemplate
